module.exports = __webpack_public_path__ + "img/nocontest.59355e43.png";